import { useFormikContext } from 'formik';

import {
  PaymentAndRegistrationForm,
  SubmittingOverlay,
} from '#src/components/Cart';
import Container from '#src/components/Container';
import Notification from '#src/components/Notification';

import { withCheckoutForm } from '../withCheckoutForm';

import AmountDue from './AmountDue';
import GameItem from './GameItem';
import styles from './styles.module.scss';
import Discount from './Discount';

const Component = ({
  className,
  disabled,
  discounts,
  games,
  isAdHocMembershipOrder,
  order,
  paidNotification,
  removeDiscountLabel,
  removeItem,
  requiresRegistration,
  savePaymentLabel,
  setBraintreeInstance,
  setPaymentMethodReady,
  theme,
  token,
}) => {
  const { isSubmitting } = useFormikContext();
  const { amountDue } = order;
  const isOrderFinal = order.status == 'final';
  const totalAmount =
    order.orderItems?.find(({ type } = {}) => type === 'GameOrderItem')
      ?.amount || amountDue;

  return (
    <>
      {isSubmitting && <SubmittingOverlay />}

      <Container className={className} outerClassName={styles.outerContainer}>
        <h2 className={styles.header}>Join the challenge!</h2>

        {isOrderFinal && <Notification>{paidNotification}</Notification>}

        <div className={styles.container}>
          <Container className={styles.gameDetailsContainer}>
            <div className={styles.gameDetails}>
              {games?.map?.(({ game }) => (
                <GameItem key={game.id} amountDue={totalAmount} game={game} />
              ))}
              <div className={styles.discounts}>
                {discounts.map((item) => (
                  <Discount
                    key={item.id}
                    theme={theme}
                    content={{ removeDiscountLabel }}
                    item={item}
                    onRemove={removeItem}
                  />
                ))}
              </div>
              <AmountDue amountDue={amountDue} />
            </div>
          </Container>

          {!isOrderFinal && (
            <PaymentAndRegistrationForm
              className={styles.paymentForm}
              ctaLabel="Join Now"
              ctaDisabled={disabled}
              isAdHocMembershipOrder={isAdHocMembershipOrder}
              order={order}
              requiresRegistration={requiresRegistration}
              savePaymentLabel={savePaymentLabel}
              setBraintreeInstance={setBraintreeInstance}
              setPaymentMethodReady={setPaymentMethodReady}
              theme={theme}
              token={token}
            />
          )}
        </div>
      </Container>
    </>
  );
};

export const RoutinesCart = withCheckoutForm(Component);
